<app-pagetitle title="Lista de documentos" [breadcrumbItems]="breadCrumbItems"></app-pagetitle>


<div class="row">
    <div class="col-xl-12">
        <!-- card -->
        <div class="card card-h-100">
            <!-- card body -->
            <div class="card-body">
                <div class="d-flex flex-wrap align-items-center mb-4">
                    <h5 class="card-title me-2">Documentos por status</h5>
                    <div class="ms-auto">
                        <div [formGroup]="filtroForm" class="mb-3">
                            <label for="ano" class="form-label">Ano</label>
                            <input formControlName="ano" class="form-control" type="number">
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-xl-3 col-md-6">
                        <!-- card -->
                        <div class="card card-h-100">
                            <!-- card body -->
                            <div class="card-body">
                                <div class="row align-items-center">
                                    <div class="col-12">
                                        <span class="text-muted mb-3 d-block">Status Documentos</span>
                                        <h4 class="mb-1">
                                            <span class="counter-value"></span>{{qtddStatusCancelado}}
                                        </h4>
                                    </div>

                                </div>
                                <div class="text-nowrap">
                                    <span class="badge bg-danger-subtle text-danger">Cancelado</span>
                                </div>
                            </div><!-- end card body -->
                        </div><!-- end card -->
                    </div><!-- end col -->

                    <div class="col-xl-3 col-md-6">
                        <!-- card -->
                        <div class="card card-h-100">
                            <!-- card body -->
                            <div class="card-body">
                                <div class="row align-items-center">
                                    <div class="col-12">
                                        <span class="text-muted mb-3 d-block">Status Documentos</span>
                                        <h4 class="mb-1">
                                            <span class="counter-value"></span>{{atddStatusFinalizado}}
                                        </h4>
                                    </div>

                                </div>
                                <div class="text-nowrap">
                                    <span class="badge bg-success-subtle text-success">Finalizado</span>
                                </div>
                            </div><!-- end card body -->
                        </div><!-- end card -->
                    </div><!-- end col-->

                    <div class="col-xl-3 col-md-6">
                        <!-- card -->
                        <div class="card card-h-100">
                            <!-- card body -->
                            <div class="card-body">
                                <div class="row align-items-center">
                                    <div class="col-12">
                                        <span class="text-muted mb-3 d-block">Status Documentos</span>
                                        <h4 class="mb-1">
                                            <span class="counter-value"></span>{{qtddStatusAguardandoSignatario}}
                                        </h4>
                                    </div>

                                </div>
                                <div class="text-nowrap">
                                    <span class="badge bg-secondary-subtle text-secondary">Aguardando Signatários</span>
                                </div>
                            </div><!-- end card body -->
                        </div><!-- end card -->
                    </div><!-- end col -->


                    <div class="col-xl-3 col-md-6">
                        <!-- card -->
                        <div class="card card-h-100">
                            <!-- card body -->
                            <div class="card-body">
                                <div class="row align-items-center">
                                    <div class="col-12">
                                        <span class="text-muted mb-3 d-block">Status Documentos</span>
                                        <h4 class="mb-1">
                                            <span class="counter-value"></span>{{atddStatusAguardandoAssinatura}}
                                        </h4>
                                    </div>

                                </div>
                                <div class="text-nowrap">
                                    <span class="badge bg-info-subtle text-info">Aguardando Assinaturas</span>
                                </div>
                            </div><!-- end card body -->
                        </div><!-- end card -->
                    </div><!-- end col -->
                </div><!-- end row-->
            </div>
        </div>
    </div>
    <!-- end col -->


</div>

<div class="row">
    <div class="col-12">
        <div class="card">
            <div class="card-header">
                <!-- <h4 class="card-title">Documentos</h4> -->
                <p class="card-title-desc">Lista de documentos e seus respectivos projetos e clientes.
                </p>
            </div>
            <div class="card-body">

                <div id="datatable_wrapper" class="dataTables_wrapper dt-bootstrap4 no-footer">
                    <div class="row">
                        <div class="col-sm-12 col-md-6">

                        </div>

                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <table id="datatable"
                                class="table-striped table table-bordered dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
                                aria-describedby="datatable_info" style="width: 1151px;">
                                <thead>
                                    <tr>
                                        <th class="sorting sorting_asc" tabindex="0" aria-controls="datatable"
                                            rowspan="1" colspan="1" style="width: 178.889px;" aria-sort="ascending"
                                            aria-label="Name: activate to sort column descending">Projeto</th>
                                        <th class="sorting" tabindex="0" aria-controls="datatable" rowspan="1"
                                            colspan="1" style="width: 278.889px;"
                                            aria-label="Position: activate to sort column ascending">Cliente</th>
                                        <th class="sorting" tabindex="0" aria-controls="datatable" rowspan="1"
                                            colspan="1" style="width: 136.889px;"
                                            aria-label="Office: activate to sort column ascending">Feira</th>
                                        <th class="sorting" tabindex="0" aria-controls="datatable" rowspan="1"
                                            colspan="1" style="width: 65.8889px;"
                                            aria-label="Age: activate to sort column ascending">Status</th>
                                        <th class="sorting" tabindex="0" aria-controls="datatable" rowspan="1"
                                            colspan="1" style="width: 65.8889px;"
                                            aria-label="Age: activate to sort column ascending">Ações</th>

                                    </tr>
                                </thead>


                                <tbody>
                                    @if (assinarDocumentoService.loading) {
                                    <tr>
                                        <td colspan="7" class="text-center position-relative">
                                            <div class="d-flex justify-content-center align-items-center"
                                                style="height: 150px">
                                                <span class="spinner-border" style="width: 3rem; height: 3rem"
                                                    role="status" aria-hidden="true"></span>
                                            </div>
                                        </td>
                                    </tr>
                                    } @else {
                                    @for (row of documentosAssinaturas; track $index) {

                                    <tr class="odd">
                                        <td class="dtr-control sorting_1" tabindex="0">{{ row.descricaoProjeto }}</td>
                                        <td>{{ row.cliente }}</td>
                                        <td>{{ row.feira }}</td>
                                        <td>{{ row.descricaoStatus }}</td>
                                        <td>
                                            <div class="dropdown" ngbDropdown>

                                                <button
                                                    class="btn btn-link font-size-16 shadow-none py-0 text-muted dropdown-toggle"
                                                    type="button" data-bs-toggle="dropdown" aria-expanded="false"
                                                    ngbDropdownToggle>
                                                    <i class="bx bx-dots-horizontal-rounded"></i>
                                                </button>
                                                <ul class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
                                                    <li>
                                                        <a class="dropdown-item" href="javascript:void(0);"
                                                            [routerLink]="['/clientes', row.clienteId]"
                                                            [queryParams]="{ extra: 2 }">
                                                            Ver Projeto
                                                        </a>
                                                    </li>

                                                    <li>
                                                        <a class="dropdown-item" href="javascript:void(0);"
                                                            [routerLink]="'/telemarketing/projetos/contrato/' + row.contratoId ">
                                                            Ver Contrato
                                                        </a>
                                                    </li>

                                                </ul>

                                            </div>
                                        </td>

                                    </tr>
                                    }
                                    }

                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12 col-md-5">
                            <div class="dataTables_info" id="datatable_info" role="status" aria-live="polite"></div>
                        </div>
                        <div class="col-sm-12 col-md-7">
                            <ngb-pagination [collectionSize]="paginacao.totalDeItens"
                                [pageSize]="paginacao.quantidadePorPagina" [(page)]="paginacao.paginaAtual"
                                [maxSize]="3" [rotate]="false" [ellipses]="true" [boundaryLinks]="true"
                                (pageChange)="onPageChange($event)">
                            </ngb-pagination>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div> <!-- end col -->
</div>